import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { FaqCategoryService } from '../faq-category.service';
import { FaqCategory } from '../faq-category';
import { DevelopmentService } from '@app/_components/development/development.service';
import { PropertyService } from '@app/_components/property/property.service';

@Component({
    selector: 'app-faq-category',
    templateUrl: './faq-category.component.html',
    styleUrls: ['./faq-category.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class FaqCategoryComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private faqCategoryService: FaqCategoryService,
		private developmentService: DevelopmentService,
		private propertyService: PropertyService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.faqCategory = data.faqCategory,
			this.statuses = faqCategoryService.statuses;
	}

	@Input() faqCategory: FaqCategory;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	faqCategoryId: number;
	showPagination = false;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	// Scope selector data
	developmentOptions: any[] = [];
	propertyOptions: any[] = [];
	locationOptions: { label: string; value: number }[] = [
		{ label: 'Maui', value: 1 },
		{ label: 'Park City', value: 2 },
		{ label: 'Big Island', value: 3 },
		{ label: 'Oahu', value: 4 },
		{ label: 'San Diego', value: 5 },
		{ label: 'Aspen', value: 6 },
		{ label: 'Vail', value: 7 },
		{ label: 'Sun Valley', value: 8 },
		{ label: 'Bass Lake', value: 9 },
		{ label: 'Yosemite', value: 10 },
	];
	adrRegionOptions: { label: string; value: string }[] = [
		{ label: 'Hawaii (HI)', value: 'HI' },
		{ label: 'Utah (UT)', value: 'UT' },
		{ label: 'California (CA)', value: 'CA' },
		{ label: 'Idaho (ID)', value: 'ID' },
		{ label: 'Colorado (CO)', value: 'CO' },
	];

	validationMessages = {
		'faqCategoryId': [],
		'name': [
			{ type: 'required', message: 'Required' }
		],
		'faqCategoryGroupId': [
			{ type: 'required', message: 'Required' }
		],
		'enabled': [],
		'description': [],
		opsNotes: [],
		introDesc: [],
		shortTermRentalId: [],
		developmentId: [],
		locationId: [],
		adrRegion: [],
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole faqCategory object
		if (this.faqCategory) {
			this.faqCategoryId = this.faqCategory.faqCategoryId;
			this.fixDates();
			this.form1.patchValue(this.faqCategory);
		}

		this.loadScopeOptions();
	}

	private loadScopeOptions(): void {
		this.developmentService.developmentSummaryList().subscribe({
			next: (res: any) => {
				const items: any[] = res?.data?.developmentSummaryList || [];
				this.developmentOptions = items
					.filter((d: any) => d.developmentId && d.addressDevelopmentName)
					.sort((a: any, b: any) => (a.addressDevelopmentName || '').localeCompare(b.addressDevelopmentName || ''));
			},
			error: () => {}
		});

		this.propertyService.findAllSummaryWithStatusActive().subscribe({
			next: (res: any) => {
				const items: any[] = res?.data?.shortTermRentalSummary || res?.data?.shortTermRentalList || [];
				this.propertyOptions = items
					.filter((p: any) => p.shortTermRentalId && p.propertyCode)
					.sort((a: any, b: any) => (a.propertyCode || '').localeCompare(b.propertyCode || ''));
			},
			error: () => {}
		});
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.faqCategoryId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.faqCategoryService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.faqCategory = res.data.faqCategory;
						this.faqCategoryId = this.faqCategory.faqCategoryId;
						this.doAdd.emit(this.faqCategory);
					},
					(err: any) => {
						console.log('faqCategory-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('faqCategory: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.faqCategoryService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.faqCategory = res.data.faqCategory;
						this.doUpdate.emit(this.faqCategory);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.faqCategoryService.delete(this.faqCategory.faqCategoryId)
				.subscribe(
					(res: any) => {
						console.log('faqCategory-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.faqCategory);
					},
					(err: any) => {
						console.log('faqCategory-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			faqCategoryId: [this.faqCategoryId],
			name: ['', Validators.required],
			faqCategoryGroupId: ['', Validators.required],
			enabled: [true],
			description: [],
			opsNotes: [],
			introDesc: [],
			shortTermRentalId: [null],
			developmentId: [null],
			locationId: [null],
			adrRegion: [null],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.faqCategory.faqCategoryDate = moment(this.faqCategory?.faqCategoryDate).toDate();
	}

	getLiveWebsiteUrl(){
		if(this.faqCategory?.faqCategoryGroupId === 'carreers_group'){
			return "https://www.kbmresorts.com/careers";
		} else{
			return "https://www.kbmresorts.com/"+this.faqCategory?.faqCategoryGroupId;
		}
	}
}
